import BaseInput from '../BaseInput';
import React from 'react';
import { PatternFormat } from 'react-number-format';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

const InputPhone = ({ value, onChange, placeholder }: Props) => {
  return (
    <PatternFormat
      format='(###) ###-####'
      value={value}
      valueIsNumericString={true}
      onValueChange={(values) => {
        onChange?.(values.value);
      }}
      customInput={BaseInput}
      placeholder={placeholder}
    />
  );
};

export default InputPhone;
